<div
  class="mbs-form"
  [formGroup]="adminSearchForm">
  <div class="row py-1 mb-3">
    <div class="col-12">
      <mbs-input
        formControlName="name"
        [placeholder]="'shared:placeholders.search' | i18next"
        [appendButtons]="[
          {
            type: 'secondary',
            icon: 'ico ico-Search'
          }
        ]"
        [clearButton]="true"
        (buttonClick)="search()"
        (clear)="clear()"
        [buttonClickOnEnter]="true"
        [disabledSelf]="loading">
      </mbs-input>
    </div>
  </div>
</div>

<mbs-table-grid
  [headers]="headers"
  [loading]="loading"
  [data]="data"
  [selectedItems]="selected"
  (changeSelected)="onSelectedRowsChanged($event)"
  [multipleSelect]="multipleSelect"
  [showSelectAllCheckbox]="true"
  [selectAllIgnoreDisabled]="true"
  [showTableCheckboxes]="true"
  [showSelectAllHint]="true"
  [selectable]="true"
  [infiniteScroll]="true"
  [keepState]="true"
  [infiniteScrollDistance]="infiniteScrollDistance"
  [infiniteScrollThrottle]="infiniteScrollThrottle"
  [infiniteScrollLoading]="infiniteScrollLoading"
  (scrolled)="onScrolled$.next(true)"
  [myTrackBy]="trackBy"
  [serverSidePagination]="false"
  [maxHeight]="'50vh'"
  [noDataMessage]="noDataText"
  [totalItems]="total"
  [selectedCountText]="selectedText()"
  [selectAllButtonText]="selectAllText()"
  (selectAllOnAllPages)="selectAllOnAllPages($event)"
  [cancelSelectionText]="'shared:paging.cancelSelection' | i18next">
  <ng-template
    mbsTableCell
    let-item>
    {{ item.email }}
  </ng-template>
</mbs-table-grid>
